import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, PropType } from 'vue'
import fbu from './fbu/index.vue'
import lbu from './lbu/index.vue'
import zbu from './zbu/index.vue'
import ofbu from './ofbu/index.vue'
import { tableIdByPath } from '@/utils'

const __default__ = {
  name: 'TabsContacts'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  appId: {
    type: String,
    default: 'cos_fbu'
  },
  permissionPage: {
    type: Object as PropType<{
      edit: string
      del: string
    }>,
    default: () => {
      return {}
    }
  }
},
  setup(__props, { expose: __expose }) {

const fbuRef = ref()
const lbuRef = ref()
const zbuRef = ref()
const ofbuRef = ref()
const props = __props

const refresh = (type?: 'add' | 'edit') => {
  switch (props.appId) {
    case 'cos_fbu':
      fbuRef.value.refresh(type)
      break
    case 'cos_lbu':
      lbuRef.value.refresh(type)
      break
    case 'cos_zbu':
      zbuRef.value.refresh(type)
      break
    case 'cos_ofbu':
      ofbuRef.value.refresh(type)
      break
  }
}
__expose({
  refresh
})

return (_ctx: any,_cache: any) => {
  return (__props.appId === 'cos_fbu')
    ? (_openBlock(), _createBlock(fbu, _mergeProps({
        key: 0,
        tableId: _unref(tableIdByPath)('contacts')
      }, _ctx.$attrs, {
        permissionPage: __props.permissionPage,
        ref_key: "fbuRef",
        ref: fbuRef
      }), null, 16, ["tableId", "permissionPage"]))
    : (__props.appId === 'cos_lbu')
      ? (_openBlock(), _createBlock(lbu, _mergeProps({ key: 1 }, _ctx.$attrs, {
          tableId: _unref(tableIdByPath)('contacts'),
          permissionPage: __props.permissionPage,
          ref_key: "lbuRef",
          ref: lbuRef
        }), null, 16, ["tableId", "permissionPage"]))
      : (__props.appId === 'cos_zbu')
        ? (_openBlock(), _createBlock(zbu, _mergeProps({ key: 2 }, _ctx.$attrs, {
            tableId: _unref(tableIdByPath)('contacts'),
            permissionPage: __props.permissionPage,
            ref_key: "zbuRef",
            ref: zbuRef
          }), null, 16, ["tableId", "permissionPage"]))
        : (__props.appId === 'cos_ofbu')
          ? (_openBlock(), _createBlock(ofbu, _mergeProps({ key: 3 }, _ctx.$attrs, {
              tableId: _unref(tableIdByPath)('contacts'),
              permissionPage: __props.permissionPage,
              ref_key: "ofbuRef",
              ref: ofbuRef
            }), null, 16, ["tableId", "permissionPage"]))
          : _createCommentVNode("", true)
}
}

})